'use strict';
import isArray from 'lodash/isArray';
import {getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {SortMethod} from '../../core-utilities/filters/SortMethod';
import {logger} from './logger';


ProjectAssetsFilterService.$inject = [
  '$filter',
];

export function ProjectAssetsFilterService(
  $filter,
) {
  this.createAssetProjectsFilter = createAssetProjectsFilter;
  this.filterAssetsOptions = filterAssetsOptions;
  this.sortAssetsOptions = sortAssetsOptions;
  this.sortByAssetProjects = sortByAssetProjects;

  function createAssetProjectsFilter(assetProjectList) {
    const results = {};

    try {
      for (const assetProjectId in assetProjectList) {
        if (assetProjectList.hasOwnProperty(assetProjectId)) {
          const assetId = getLink(assetProjectList[assetProjectId], 'asset').id;
          results[assetId] = assetProjectList[assetProjectId].status;
        }
      }
    } catch (err) {
      logger.error({err}, 'failed to createAssetProjectsFilter');
    }

    return results;
  }

  // filter on options or list change
  function filterAssetsOptions(list, options, filter) {
    return list.filter(asset => asset && !asset.isDeleting && !filterOnStatus(getId(asset), options, filter, list));
  }

  function filterOnStatus(key, options, filter, list) {
    try {
      // Assignment filters
      // TODO: convert to accept a task or date instead?
      const status = filter ? filter[key] : null;

      if (!options.inProject.yes && status) return true;

      if (!options.inProject.no && !status) return true;

      if (status && !options.status[status]) return true;

      return false;
    } catch (err) {
      logger.error({err, list, options}, 'error with filterAssetsOptions');
      return false;
    }
  }

  function sortAssetsOptions(list, sortOptions) {
    let results;
    if (!isArray(list)) {
      results = [];

      for (const key in list) {
        if (list.hasOwnProperty(key)) {
          results.push(list[key]);
        }
      }

      list = results;
    }

    const method = SortMethod.valueOf(sortOptions.currentMethod) || SortMethod.ASCENDING;
    if (method === $filter.SORT_METHODS.NONE) {
      return list.sort($filter.$sortByProperty('$id', true));
    } else {
      return list.sort($filter.$sortByProperty(sortOptions.property, method.val, true));
    }
  }

  function sortByAssetProjects(assets, assetProjectsFilter) {
    const inProject = [];
    const notInProject = [];

    for (let i = 0, length = assets.length; i < length; i++) {
      const id = getId(assets[i]);
      if (assetProjectsFilter[id]) {
        inProject.push(assets[i]);
      } else {
        notInProject.push(assets[i]);
      }
    }

    return inProject.concat(notInProject);
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/filters/ProjectAssetsFilterService.js